import { Media } from '../../model/components/Media';
import { FileInput, FileType } from './FileInput';

const FILE_TYPE_TO_MEDIA_TYPE_MAP: Record<FileType, Media['mediaType']> = {
    video: 'Video',
    image: 'Image',
};
const MEDIA_TYPE_TO_FILE_TYPE_MAP: Record<Media['mediaType'], FileType> = {
    Video: 'video',
    Image: 'image',
};
export interface MediaInputProps {
    value?: Media;
    onChange?: (media?: Media) => void;
}
export const MediaInput = ({ value, onChange }: MediaInputProps) => {
    return (
        <FileInput
            onChange={(file) => {
                onChange?.(
                    file
                        ? {
                              url: file.url,
                              mediaType:
                                  FILE_TYPE_TO_MEDIA_TYPE_MAP[file.fileType],
                          }
                        : undefined,
                );
            }}
            value={
                value
                    ? {
                          url: value.url,
                          fileType:
                              MEDIA_TYPE_TO_FILE_TYPE_MAP[value.mediaType],
                      }
                    : undefined
            }
        />
    );
};
